import React from 'react';

export enum TITLES {
  CLIENT = 'Client',
  FLIGHT_NAME = 'Flight name',
  ORIGIN_AIRPORT = 'Origin Airport',
  DESTINATION_AIRPORT = 'Destination Airport',
  ORIGIN_CITY = 'Origin city',
  DESTINATION_CITY = 'Destination City',
  ORIGIN_COUNTRY = 'Origin country',
  DESTINATION_COUNTRY = 'Destination country',
  FLIGHT_ID = 'Flight ID',
  FLIGHT_DUE_DATE = 'Flight due date',
  DEPARTURE_TIME = 'Departure time',
  ARRIVAL_TIME = 'Arrival time',
  FLIGHT_DURATION = 'Flight Duration',
  ARRIVAL_TYPE = 'Arrival type',
  FLIGHT_DATE_FINISH = 'Flight date finish',
  MY_PRICE = 'My Price',
  LAST_SCAN = 'Last Scan',
  CABIN_BAGGAGE_PRICE = 'Cabin baggage price',
  CHECKED_BAGGAGE_PRICE = 'Checked baggae price',
  AIRCRAFT = 'Aircraft',
  PRICE_VS_MARKET = 'Price Vs. Market',
  PRICE_VS_BRITISH_AIRWAYS = 'Price Vs. British-airways',
  PRICE_VS_BLUE_AIR = 'Price Vs. Blue-air',
  PRICE_VS_WIZZ_AIR = 'Price Vs. Wizz-air',
  PRICE_VS_RYANAIR = 'Price Vs. Ryanair',
  PRICE_VS_EASY_JET = 'Price Vs. Easy-jet',
  MARKET_PRICE = 'Market price',
  BRITIS_AIRWAYS_PRICE = 'British-airways price',
  BLUE_AIR_PRICE = 'Blue-air price',
  WIZZ_AIR_PRICE = 'Wizz-air price',
  RYANAIR_PRICE = 'Ryanair price',
  EASY_JET_PRICE = 'Easy-jet price',
  MARKET_PRICE_AVG = 'Market price avg',
    BRITIS_AIRWAYS_PRICE_AVG = 'British-airways price avg',
    BLUE_AIR_PRICE_AVG = 'Blue-air price avg',
    WIZZ_AIR_PRICE_AVG = 'Wizz-air price avg',
    RYANAIR_PRICE_AVG = 'Ryanair price avg',
    EASY_JET_PRICE_AVG = 'Easy-jet price avg',
  PRICE_DIFFERENCE = 'Price diff',
}

export enum AIRPORT_TITLES {
  AIRPORT = 'Airport',
  FLIGHTS = '# Flights',
  COMPETITOR = 'Competitor',
  CLIENT = 'Client',
  ORIGIN_AIRPORT = 'Origin Airport',
  DESTINATION_AIRPORT = 'Destination Airport',
  ORIGIN_CITY = 'Origin city',
  DESTINATION_CITY = 'Destination City',
  ORIGIN_COUNTRY = 'Origin country',
  DESTINATION_COUNTRY = 'Destination country',
  FLIGHT_ID = 'Flight ID',
  FLIGHT_DUE_DATE = 'Flight due date',
  DEPARTURE_TIME = 'Departure time',
  ARRIVAL_TIME = 'Arrival time',
  FLIGHT_DURATION = 'Flight Duration',
  ARRIVAL_TYPE = 'Arrival type',
  FLIGHT_DATE_FINISH = 'Flight date finish',
  MY_PRICE = 'My Price',
  LAST_SCAN = 'Last Scan',
  CABIN_BAGGAGE_PRICE = 'Cabin baggage price',
  CHECKED_BAGGAGE_PRICE = 'Checked baggae price',
  AIRCRAFT = 'Aircraft',
  PRICE_VS_MARKET = 'Price Vs. Market',
  PRICE_VS_BRITISH_AIRWAYS = 'Price Vs. British-airways',
  PRICE_VS_BLUE_AIR = 'Price Vs. Blue-air',
  PRICE_VS_WIZZ_AIR = 'Price Vs. Wizz-air',
  PRICE_VS_RYANAIR = 'Price Vs. Ryanair',
  PRICE_VS_EASY_JET = 'Price Vs. Easy-jet',
  DESTINATION_CONTINENT = 'Destination Continent',
}
export enum COMPETITORS {
  COMPETITOR = 'Competitor',
  FLIGHT_NAME = 'Flight name',
  ORIGIN_AIRPORT = 'Origin Airport',
  DESTINATION_AIRPORT = 'Destination Airport',
  ORIGIN_CITY = 'Origin city',
  DESTINATION_CITY = 'Destination City',
  ORIGIN_COUNTRY = 'Origin country',
  DESTINATION_COUNTRY = 'Destination country',
  FLIGHT_ID = 'Flight ID',
  FLIGHT_DUE_DATE = 'Flight due date',
  DEPARTURE_TIME = 'Departure time',
  ARRIVAL_TIME = 'Arrival time',
  FLIGHT_DURATION = 'Flight Duration',
  ARRIVAL_TYPE = 'Arrival type',
  FLIGHT_DATE_FINISH = 'Flight date finish',
  MY_PRICE = 'My Price',
  LAST_SCAN = 'Last Scan',
  CABIN_BAGGAGE_PRICE = 'Cabin baggage price',
  CHECKED_BAGGAGE_PRICE = 'Checked baggae price',
  AIRCRAFT = 'Aircraft',
}

export interface DataType {
  key: React.Key;
  Client: string;
  'Flight name': string;
  'Origin Airport': string;
  'Destination Airport': string;
  'Origin city': string;
  'Destination City': string;
  'Origin country': string;
  'Destination country': string;
  'Flight ID': string;
  'Flight due date': string;
  'Departure time': string;
  'Arrival time': string;
  'Flight Duration': string;
  'Arrival type': string;
  'Flight date finish': string;
  'My Price': string;
  'Last Scan': string;
  'Cabin baggage price': string | null;
  'Checked baggae price': string | null;
  Aircraft: string;
}

enum ArrivalType {
  Morning = 'Morning',
  Noon = 'Noon',
  AfterNoon = 'After noon',
  Evening = 'Evening',
  Night = 'Night',
  AfterMidnight = 'After midnight',
}
